export const ApiReferenceSectionIds = {
  MAIN: 'main-content',
} as const;

export enum ApiReferenceEnums {
  PAGE_TITLE = 'API Reference',
  PAGE_SUBTITLE = 'Carbon One — external HTTP API',
  BREADCRUMB_CURRENT = 'Documentation',
  SKIP_LINK = 'Skip to content',
  SIDEBAR_OVERVIEW = 'Overview',
  SIDEBAR_ENDPOINTS = 'Endpoints',
  SIDEBAR_REFERENCE = 'Reference',
  ON_THIS_PAGE = 'On this page',
  LAST_UPDATED_PREFIX = 'Last updated on',

  H1_REFERENCE = 'Carbon One API (v1)',
  HERO_LEAD = 'External read-only API for accessing organizational carbon data.',

  H2_ENDPOINTS = 'Endpoints',
  ENDPOINTS_INTRO = 'Read-only GET endpoints for organizational carbon data under the base path below.',

  SECTION_DESCRIPTION = 'Description',
  SECTION_REQUEST_PARAMS = 'Query parameters',
  SECTION_HEADERS = 'Headers',
  SECTION_REQUEST_EXAMPLE = 'Sample request',
  SECTION_RESPONSE_EXAMPLE = 'Sample response',
  SECTION_FIELDS = 'Field explanation',
  SECTION_BUSINESS_NOTES = 'Business logic notes',
  SECTION_ERRORS = 'Error responses',
  SECTION_NOTES = 'Notes',
  URL_LABEL = 'URL',
  METHOD_LABEL = 'Method',

  BANNER_HTTPS = 'HTTPS is required for all authenticated requests.',
  BANNER_HTTPS_DESC = 'TLS is enforced at the load balancer. Requests over plain HTTP may be blocked before reaching the application.',

  COPY_BUTTON = 'Copy',
  COPIED_BUTTON = 'Copied',

  AUTH_REQUIRED_BADGE = 'Auth required',
  REQUIRED_BADGE = 'Required',
  OPTIONAL_BADGE = 'Optional',
  NO_QUERY_PARAMS = 'This endpoint accepts no query parameters. Any extra key returns 400 Bad Request.',

  TRY_IT_TITLE = 'Try it',
  TRY_IT_DESC = 'Paste a test API key below. The curl snippet updates automatically — copy and run it from your terminal.',
  TRY_IT_PLACEHOLDER = 'carbonone_sk_your_key_here',
  TRY_IT_LABEL = 'API key',

  QUICK_REF_TITLE = 'Quick reference — allowlists',
  QUICK_REF_INTRO = 'Each endpoint strictly accepts only the query parameter names listed below.',

  ERROR_HANDLING_TITLE = 'Error handling',
  ERROR_HANDLING_INTRO = 'Errors are returned as JSON. Common status codes are summarized below.',

  RATE_LIMITS_TITLE = 'Rate limits',
  GLOBAL_CONVENTIONS_TITLE = 'Global conventions',

  TABLE_PARAM = 'Parameter',
  TABLE_TYPE = 'Type',
  TABLE_REQUIRED = 'Required',
  TABLE_DESCRIPTION = 'Description',
  TABLE_HEADER = 'Header',
  TABLE_VALUE = 'Value',
  TABLE_FIELD = 'Field',
  TABLE_STATUS = 'Status',
  TABLE_SITUATION = 'Situation',
  TABLE_MESSAGE = 'Message',
  TABLE_ENDPOINT = 'Endpoint',
  TABLE_ALLOWED = 'Allowed query parameters',

  YES = 'Yes',
  NO = 'No',
  NONE = '(none)',
}

export enum ApiReferenceCodeLabels {
  AUTH_HEADER = 'Authorization',
}
